module.exports = __webpack_public_path__ + "static/img/pcl1.e0568470.png";